/* eslint-disable max-len */

export default {
  lang: 'Portuguese',
  homeScreen: {
    title: 'Capital Mundial dos Parques Temáticos',
    stayConnected: 'Continue conectado',
    comingSoon: 'Em breve',
    messages: 'Mensagens',
  },
  loginScreen: {
    forgot: 'Esqueceu a senha',
    title: 'Programa de capacitação de vendas e treinamento de agentes de viagens',
    welcome: {
      headerTop: 'Bem-vindo à',
      headerBottom: 'Travel Nevada',
    },
    sellingPoints: {
      0: 'Aprenda, promova e venda em qualquer lugar',
      1: 'Treinamento multimídia em vários dispositivos',
      2: 'Certificado de conclusão',
      3: 'Apresentações de vendas prontas',
      4: 'Materiais promocionais de alto impacto',
      5: 'Dicas e promoções exclusivas',
      6: 'Diretório de produtos em tempo real',
      7: 'Notícias e atualizações pontuais',
    },
    emailPrompt: 'Insira seu endereço de e-mail e senha para confirmar que você é um agente de viagens.',
    tAndC: {
      agree: 'Ao continuar, você concorda com a nossa',
      privacyPolicy: ' política de privacidade ',
      and: 'e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      agency: 'Agência',
      email: 'E-mail *',
      password: 'Senha *',
      passwordConfirm: 'Confirme a sua senha *',
      firstName: 'Nome *',
      lastName: 'Sobrenome *',
      city: 'Cidade *',
      agencyName: 'Nome da agência *',
      stateProvince: 'Estado/Província *',
      required: 'Obrigatório',
      invalidEmail: 'Endereço de e-mail inválido',
      opt: 'Fique por dentro! Sim, gostaria de receber comunicações da Travel Nevada para me manter informado sobre notícias, eventos, incentivos, FAMs e muito mais!',
      complete: 'Passo 2: Complete seu perfil',
      tell: 'Conte-nos sobre você',
      title: 'Título da empresa *',
      host: 'Nome da agência anfitriã',
      country: 'País / Região',
      select: 'Por favor, selecione uma opção abaixo',
      header2: 'Quais segmentos você vende principalmente?',
      step2: 'Descreva seu negócio',
      leisure: 'Lazer',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: 'Qual é a sua afiliação principal?', 
      forgot: 'Por favor, forneça o endereço de e-mail que você usou quando se inscreveu na sua conta Travel Nevada. Nós lhe enviaremos um e-mail que permitirá que você redefina sua senha.',
    },
    noAgent: {
      noAgentButton: 'Não sou um agente',
      title: 'Agradecemos pelo seu interesse na Travel Nevada.',
      messageWeb: 'O conteúdo deste site é exclusivo para agentes de viagens. Para saber mais sobre Nevada, acesse:',
      messageMobile: 'Alguns conteúdos deste aplicativo são exclusivos para agentes de viagens, mas fique à vontade para ver uma prévia do que o aplicativo tem a oferecer clicando em "Continuar".',
      continue: 'Continuar',
      visitWebsite: 'Visitar site',
    },
    newUser: 'Novo usuário',
    register: 'Cadastrar-se',
    registered: 'Este e-mail já está cadastrado',
    forgots: 'Esqueci minha senha',
     header: 'Por favor, reserve um momento para preencher todas as informações abaixo, pois é isso que preencherá seu perfil e informações de contato.',
     step1: 'Passo 1: Preencha seu endereço de e-mail e escolha uma senha.',
  },
  welcomeScreen: {
    title: 'Boas-vindas à Travel Nevada',
    helloUser: 'Olá, {{name}}',
    hello: 'Olá,',
    fromAgency: 'da {{agency}}',
    notUser: 'Você não é {{name}}?',
    introOnline: 'Faça o treinamento on-line ou pré-carregue o conteúdo para que esteja sempre disponível para uso off-line!',
    introOffline: 'Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer hora, em qualquer lugar!',
    startTraining: 'Começar a aprender',
    continueTraining: 'Continuar aprendendo',
    graduated: 'Parabéns!',
    downloader: {
      preload: 'Pré-carregar',
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última atualização:',
    },
  },
  trainingScreens: {
    start: 'Iniciar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% concluído',
    unlock: 'Libere este capítulo após concluir o capítulo de treinamento {number}.',
    unlockSubtitle: 'Libere mais capítulos após concluir os capítulos de treinamento.',
    allUnlocked: 'Você liberou todos os capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Você chegou ao final',
    retainEnd: 'Use a barra superior para navegar neste capítulo ou pressione o botão Voltar para retornar à visão geral.',
    watchListenRead: 'Assista, ouça e leia mais',
    trouble: 'Parece que você está com problemas. Releia o conteúdo das páginas anteriores e tente novamente.',
    confirm: 'Confirmar a sua resposta',
    choose: 'Escolha uma resposta',
    skip: 'Voltar >',
    viewAllTitle: 'Dica do treinamento',
    viewAll: 'Para prosseguir para a próxima página, clique nos ícones para visualizar o conteúdo complementar. Vídeos, mapas e outras informações úteis foram fornecidos para aprimorar seu treinamento e garantir que você alcance o status PRO.',
    fillBlanks: 'Preencha os espaços em branco:',
    next: 'Próxima pergunta',
    retry: 'Tentar novamente',
    fastTrackText: {
      success: 'Parabéns, você foi aprovado no curso Fast Track e liberou o restante do treinamento!',
      failed: 'Infelizmente você não foi aprovado no curso Fast Track. Você pode retomar o treinamento para obter o seu certificado!',
    },
    fastTrack: 'Seja uma Superestrela do turismo na Suíça!',
    fastTrackExplanation: 'Basta fazer o teste das páginas a seguir para ter a chance de participar do FAM para a Suíça!<br><br><span style="font-weight: bold">Você encontrará todas as respostas para as perguntas do questionário das seguintes maneiras:</span><br><br>1. No conteúdo que você aprendeu nos módulos Europa de trem e Suíça <br><br>2. E nos seguintes sites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Revise esses recursos com atenção antes de fazer o teste! Somente aqueles com as pontuações mais altas terão a chance de serem convidados para o FAM.</span>',
    fastTrackButton: 'Clique aqui para responder ao questionário de Superestrela da Suíça',
    grading: 'Sua nota final é: {grade}%',
  },
  nav: {
    home: 'Página inicial',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Guardar',
    directory: 'Diretório',
    showRoom: 'Demonstrações',
    showcases: 'Demonstrações',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Informações',
    rewards: 'Recompensas',
    media: 'Mídias',
    favorites: 'Favoritos',
    contact: 'Contato',
    reportCard: 'Ver certificado',
    accountSettings: 'Configurações da conta',
    messages: 'Mensagens',
    search: 'Pesquisar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Guardar',
    subapps: 'Módulos de MicroLearning para Socios',
    maintrainings: 'La Base',
    subtrainings: 'A experiência',
    subtrainingsFull: 'Compañeros de Ventas para Socios',
  },
  pageDescriptions: {
    train: 'Instrua, engaje e se torne um especialista.',
    showroom: '',
    retain: 'Parabéns por concluir seu treinamento! Você acabou de liberar o principal recurso para guardar os conhecimentos especializados e melhorar suas habilidades de vendas. Use essa área para responder corretamente a uma pergunta sobre um produto ou até mesmo improvisar uma apresentação de vendas a qualquer hora, em qualquer lugar e em qualquer dispositivo.',
    promote: 'Compartilhe esses itens para despertar o interesse e iniciar uma conversa com clientes e possíveis clientes.',
    sell: 'Responda às perguntas dos clientes e feche a venda como um profissional com recursos aprofundados e suporte de vendas direcionado.',
    favorites: 'Confira o conteúdo que você salvou como favorito',
    search: 'Revise todo o conteúdo',
    subapps: '',
    maintrainings: 'Comece com as informações básicas sobre Nevada e onde seus clientes podem se hospedar.',
    subtrainings: 'Obtén una Insignia de Especialista completando estos rápidos módulos para socios de un solo capítulo.',
    subtrainingsFull: 'Acelera aún más tu experiencia en Nevada y tu poder de ventas completando estos compañeros de entrenamiento y ventas de varios capítulos para obtener un certificado.',
  },
  general: {
    next: 'Avançar',
    yes: 'Sim',
    no: 'Não',
    previous: 'Voltar',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    page: 'Página',
    search: 'Pesquisar',
    logIn: 'Entrar',
    logOut: 'Sair',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Nenhum resultado foi encontrado para: {{query}}',
    noFavorites: 'Você ainda não tem favoritos.',
    noMessages: 'Você ainda não recebeu mensagens!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar tudo',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: '404 Página Não Encontrada!',
    oops: 'Ops...',
    overview: 'Voltar para a visão geral',
    complete: 'Continuar',
    courseComplete: 'Capítulo concluído!',
    chapterComplete: 'Capítulo concluído!',
    message: '{count} mensagem',
    messagePlural: '{count} mensagens',
    viewBadge: 'Ver',
    viewBadge2: 'Distintivo'
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os botões giratórios para corresponder à resposta',
    fitb: 'Preencha os espaços em branco',
    flip: 'Altere o número para corresponder à resposta',
    multipleChoice: 'Escolha as respostas corretas',
    slider: 'Escolha a resposta correta usando o controle deslizante',
    map: 'Responda à pergunta tocando no local certo no mapa',
    dropdown: 'Escolha...',
    true: 'Verdadeiro',
    false: 'Falso',
  },
  reportCard: {
    download: 'Baixar',
    email: 'E-mail',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'CONCORDAR',
    optout: 'Recusar',
    settings: 'Configurações de privacidade',
    message: 'Você não nos informou suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a você a melhor experiência usando o Assistente de vendas.',
    disabled: 'Parece que você desativou o uso de cookies.',
    use: 'O aplicativo {{appName}} requer o uso de cookies para proporcionar a melhor experiência.',
    details: 'Para que servem os cookies?',
    enable: 'Veja como habilitar seus cookies {{here}}.',
    here: 'aqui',
  },
  notLoggedIn: {
    super: 'Você não está conectado',
    title: 'Você precisa fazer login para ver este conteúdo',
    guest: 'Convidado',
  },
  demo: {
    message: 'Este site é uma demonstração do produto final. Atualmente, ele está em desenvolvimento e não representa um produto completo.',
    consent: 'Certo!',
  },
  share: {
    header: 'Compartilhe este recurso nas suas redes sociais favoritas!',
    download: 'Baixar',
  },
  sharing: {
    copyURL: 'Copiar link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que você está tentando acessar o aplicativo {appName} a partir de um dispositivo móvel',
    body: 'Para baixar esse programa, acesse sua loja de aplicativos e pesquise por {appName} ou clique em um dos botões abaixo',
    benefits: {
      1: 'Aprenda, promova e venda em qualquer lugar',
      2: 'Treinamento multimídia em vários dispositivos',
      3: 'Certificado de conclusão',
      4: 'Apresentações de vendas prontas',
      5: 'Materiais promocionais de alto impacto',
      6: 'Diretório de produtos em tempo real',
      7: 'Notícias e atualizações pontuais',
      header: 'Isso fornecerá:',
    },
  },
  directory: {
    attractions: 'Atrações',
    hotels: 'Hotéis',
    dining: 'Jantar',
    nightlife: 'Vida noturna',
    artsculturehistory: 'Artes, Cultura e História',
    themeparks: 'Parques temáticos',
    sportsrecreationoutdoors: 'Esportes, Recreação e Atividades ao ar livre',
    otheraccommodations: 'Outras acomodações',
    shopping: 'Compras',
    weddingservices: 'Serviços de casamento',
    golf: 'Golfe',
    transportationservices: 'Serviços de transporte',
    spas: 'Spas',
    medicalservices: 'Serviços médicos',
    filters: 'Filtros',
    reset: 'Redefinir filtros',
    view: 'Veja Agora',
    amount: 'Quantidade de resultados',
  },
  custom: {
    splitUsers: 'Eu sou...',
    brandAmbassador: 'Embaixador da marca',
    travelPro: 'Profissional de viagens',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
